import { useEffect } from "react";

interface UseVideoKeyboardShortcutsProps {
  handlePrevVideo: () => void;
  handleNextVideo: () => void;
  handlePlayPause: () => void;
  handleSkipBack: () => void;
  handleSkipForward: () => void;
  currentVideoIndex: number;
  totalVideos: number;
  isPlaying: boolean;
  disabled?: boolean;
}

export const useVideoKeyboardShortcuts = ({
  handlePrevVideo,
  handleNextVideo,
  handlePlayPause,
  handleSkipBack,
  handleSkipForward,
  currentVideoIndex,
  totalVideos,
  isPlaying,
  disabled = false,
}: UseVideoKeyboardShortcutsProps) => {
  useEffect(() => {
    if (disabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Only handle if not typing in an input
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          handlePrevVideo();
          break;
        case 'ArrowDown':
          e.preventDefault();
          handleNextVideo();
          break;
        case ' ':
          e.preventDefault();
          handlePlayPause();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          handleSkipBack();
          break;
        case 'ArrowRight':
          e.preventDefault();
          handleSkipForward();
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    disabled,
    currentVideoIndex,
    totalVideos,
    isPlaying,
    handlePrevVideo,
    handleNextVideo,
    handlePlayPause,
    handleSkipBack,
    handleSkipForward,
  ]);
};
